import { Provide } from '../ioc-container/ioc-container.ts';
import { HttpResponse } from '../http/response.ts';
import { HttpRequest } from '../http/request.ts';
import { Fetch } from '../http/fetch.ts';

@Provide(Fetch)
export class FetchWrapper implements Fetch {
	async fetch(url: string, options?: HttpRequest): Promise<HttpResponse> {
		if (url.startsWith('/')) {
			url = url.substring(1);
		}
		const finalUrl: URL = new URL(
			url,
			`${window.location.protocol}//${window.location.host}${import.meta.env.BASE_URL}`,
		);
		const res = await fetch(finalUrl, options);

		const response = new ResponseWrapper(res);

		return response;
	}
}

export class ResponseWrapper implements HttpResponse {
	constructor(private response: Response) {}

	get status(): number {
		return this.response.status;
	}

	get ok(): boolean {
		return this.response.ok;
	}

	get headers(): Headers {
		return this.response.headers;
	}

	json<TResponse>(): Promise<TResponse> {
		return this.response.json();
	}

	text(): Promise<string> {
		return this.response.text();
	}

	blob(): Promise<Blob> {
		return this.response.blob();
	}
}
